module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/costume_03@3x-0e4384a2d639814f41dfff915ee01e24.webp";